import { Button } from '@mui/material'
import type React from 'react'
import { useAuth } from '../hooks/useAuth'

type EditButtonProps = {
  title: string
  onClick: () => void
}

export const EditButton: React.FC<EditButtonProps> = props => {
  const auth = useAuth()
  //多言語化対応
  const userLanguage = navigator.language || navigator.languages[0]
  const baseLanguage = userLanguage.split('-')[0]
  let editButtonJsx: JSX.Element
  switch (baseLanguage) {
    case 'de':
    case 'es':
    case 'it':
    case 'nl':
    case 'sv':
    case 'tr':
      editButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={props.onClick}
          sx={{
            justifyContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/29px Noto Sans JP',
            textAlign: 'center',
            border: '2px solid #282828',
            backgroundColor: '#fff16f',
            '&:hover': {
              backgroundColor: 'rgba(255, 241, 111, 0.8)',
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '49px',
            width: '250px',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {props.title}
        </Button>
      )
      break
    default:
      editButtonJsx = (
        <Button
          disabled={auth.isDisable}
          onClick={props.onClick}
          sx={{
            justifyContent: 'center',
            color: '#282828',
            font: 'normal normal bold 21px/29px Noto Sans JP',
            textAlign: 'center',
            border: '2px solid #282828',
            backgroundColor: '#fff16f',
            '&:hover': {
              backgroundColor: 'rgba(255, 241, 111, 0.8)',
            },
            boxShadow: '0px 2px 2px #00000014',
            height: '49px',
            width: '189px',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {props.title}
        </Button>
      )
  }
  return <>{editButtonJsx}</>
}
